module.exports = __webpack_public_path__ + "img/about6.97a73de6.jpg";